import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReviewsList from './reviews_list/ReviewsList';
import RankingUser from './user_ranking/RankingUser';
import HeaderDesktop from './headers/HeaderDesktop';
import HeaderMobile from './headers/HeaderMobile';
import HeaderMobileCollapse from './headers/HeaderMobileCollapse';
import NoReviews from './no_reviews/NoReviews';
import * as actions from './module';
import translations from './../translations.en.json';
import '@fiverr/globals';
import './my-reviews.scss';

class Index extends React.Component {

    constructor() {
        super();
        i18n.add(translations);

        this.toggleCollapsed = this.toggleCollapsed.bind(this);

        this.state = {
            showReviews: false
        };
    }

    toggleCollapsed() {
        this.setState({
            showReviews: !this.state.showReviews
        });
    }

    headerTitle(totalCount, sellerUserName) {
        if (this.props.gigId) {
            return i18n.t('reviews.users.user_show.count_reviews', {count: totalCount});
        } else if (this.isMe()) {
            return i18n.t('reviews.users.user_show.my_reviews');
        } else if (this.props.ps.isMobileResponsive) {
            return i18n.t('reviews.users.user_show.count_reviews', {count: totalCount});
        } else {
            return i18n.t('reviews.users.user_show.seller_reviews', {name: sellerUserName});
        }
    }

    mainClassName() {
        const collapseClass = this.props.collapse ? 'reviews-collapse' : '',
            showClass = this.state.showReviews ? 'show' : '';

        return `my-reviews js-client-service-source ${collapseClass} ${showClass}`;
    }

    userRatingCal(userRating) {
        return Math.round(userRating / 10);
    }

    isMe() {
        const ps = this.props.ps;

        return ps.currentUser ? (ps.currentUser.userName === this.props.sellerUserName) : false;
    }

    round(value) {
        return Math.round(value * 10) / 10;
    }

    render() {

        const {
            ps,
            stars,
            star_summary,
            showLoadMore,
            user_rating,
            sellerUserName,
            total_count,
            type,
            lastStar,
            fetchReviews,
            collapse,
            gigId
        } = this.props;

        const userRating = user_rating,
            totalCount = total_count ? total_count.toLocaleString() : 0,
            ratingBaseTen = this.userRatingCal(userRating),
            ratingBaseFive = this.round(userRating / 20),
            hasGigId = !!gigId;

        const header_props = {
            reviews_type: type,
            total_count: totalCount,
            general_reviews: fetchReviews,
            rating_ten: ratingBaseTen,
            rating_five: ratingBaseFive,
            title: this.headerTitle(totalCount, sellerUserName),
            hasGigId
        };

        return (
            <div className={this.mainClassName()}>
                {ps.isMobileResponsive && collapse &&
                    <HeaderMobileCollapse data={header_props}
                        toggleCollapsed={this.toggleCollapsed}/>
                }

                {ps.isMobileResponsive && !collapse &&
                    <HeaderMobile data={header_props}/>
                }

                {!ps.isMobileResponsive &&
                    <HeaderDesktop data={header_props}/>
                }

                <div className="reviews-wrap">
                    <RankingUser star_summary={star_summary}
                        rating_base_ten={ratingBaseTen}
                        rating_base_five={ratingBaseFive}
                        collapse={collapse}
                        ps={ps}/>

                    <ReviewsList stars={stars}
                        type={type}
                        fetchReviews={fetchReviews}
                        lastStar={lastStar}
                        showLoadMore={showLoadMore}
                        ps={ps}
                        gigId={gigId}/>
                </div>

                <NoReviews stars={stars}
                    type={type}/>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    stars: state.get('stars'),
    user_rating: state.get('user_rating'),
    star_summary: state.get('star_summary'),
    total_count: state.get('total_count'),
    showLoadMore: state.get('has_more_pages'),
    sellerUserName: state.get('username'),
    type: state.get('type'),
    lastStar: state.get('last_star_rating_id'),
    collapse: state.get('collapse'),
    gigId: state.get('gigId')
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./src/reviews/Reviews.js